import 'react-native-gesture-handler';
import {ImageBackground} from 'react-native-web';
import AuthStack from './component/Route/AuthStack';
import AppDrawer from './component/Route/Drawer';
import { NavigationContainer } from '@react-navigation/native';
import { onAuthStateChanged } from 'firebase/auth';
import { auth } from './component/firebase/FirebaseConfig';
import {useState} from 'react';



export default function App() {
  const [isLoad,setIsLoad]=useState(false)
 
  const thens={
  colors:{
    background:'transparent',
  },
}

    onAuthStateChanged(auth, user =>{
                                      if( user != null){setIsLoad(true);}
                                      
                                      else{setIsLoad(false);}})
  
  return (

    <ImageBackground resizeMode={'cover'}
    style={{ width: '100%', height: '100%' }}
    source={require('./assets/lava.jpeg')} > 
   
    <NavigationContainer theme={thens}   >
       
    
      


      
      {isLoad?   <AppDrawer/>:<AuthStack/>}
      
      
      
      
    </NavigationContainer>
   
    </ImageBackground>

    );}

